import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "onClick", "cta", "disabled"],
  _excluded2 = ["children", "className", "onClick", "cta"];
import classNames from 'classnames';
import React from 'react';
import './button.scss';
export var Button = function Button(_ref) {
  var children = _ref.children,
    className = _ref.className,
    onClick = _ref.onClick,
    cta = _ref.cta,
    disabled = _ref.disabled,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("button", _extends({
    className: classNames(className, 'Button2025', {
      cta: cta,
      disabled: disabled
    }),
    onClick: onClick,
    disabled: disabled
  }, props), children);
};
export var LinkButton = function LinkButton(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    onClick = _ref2.onClick,
    cta = _ref2.cta,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement("a", _extends({
    className: classNames(className, 'Button2025', {
      cta: cta
    }),
    onClick: onClick
  }, props), children);
};